import * as React from "react";

import { CONTROL_SIZES, type ControlSize } from "@/lib/size-variants";
import { cn } from "@/lib/utils";

function Input({
  className,
  type,
  inputSize = "small",
  ref,
  ...props
}: React.ComponentProps<"input"> & {
  ref?: React.Ref<HTMLInputElement>;
  /** Shared SIZE_VARIANTS scale — matches Button heights. */
  inputSize?: ControlSize;
}) {
  const spec = CONTROL_SIZES[inputSize];
  // Focus uses plain `focus:` (NOT `focus-visible:`): Chromium's focus-visible
  // heuristic doesn't reliably fire on mouse-click for text inputs here, so a
  // `focus-visible:`-only border never showed on click (you'd get the browser's
  // default outline instead). Plain `focus:` always matches. A single bright 1px
  // border (`--input-border-focus`) is the focus marker — no ring (thin, Linear).
  return (
    <input
      type={type}
      className={cn(
        "flex w-full rounded-md border bg-input-surface shadow-none transition-colors border-input-border file:border-0 file:bg-transparent file:text-sm file:font-normal file:text-foreground placeholder:text-muted-foreground focus:outline-none focus:[border-color:var(--input-border-focus)] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        spec.height,
        spec.text,
        spec.px,
        className,
      )}
      ref={ref}
      {...props}
    />
  );
}

export { Input };
